import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { localStorageService } from 'src/app/services/localstorage.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  role_id: any;
  userProfile: any;

  constructor(
    private _local: localStorageService,
    private router: Router
  ) { }

  ngOnInit() {
    this.userProfile = this._local.customGetItem('userProfileData');
    this.role_id = this.userProfile?.role_id;
    if (this.role_id == 5){
      this.router.navigate(['/app/customer/list'])
    }
  }

}
